module.exports = __webpack_public_path__ + "70461e162f959cffa6cf6bc8fc825032.MP3";